import { getValue } from ".";
import { DateFormats } from "../constants/Date";
import { Discipline, ListOptions } from "../models/Master";
import { TabData } from "../models/TabSessionStorage";
import { formatDate } from "./DateTime";

export const getFormattedDisciplines = (
  selected: number[],
  allDisciplines: Discipline[]
)=> {
  return selected
    .map((item: number) => {
      const found = allDisciplines.filter((s) => s.disciplineId === item);
      if (found.length > 0) {
        return {
          disciplineId: found[0].disciplineId,
          disciplineName: found[0].disciplineName,
          disciplineDescription: found[0].disciplineDescription,
          azCompeleteCheck: found[0].azCompeleteCheck,
          requestedVisits: null,
          effectiveFromDate: null,
          effectiveThroughDate: null,
          slotType: null,
          effectiveDateRange: null,
        };
      }
      return null;
    })
    .filter((item) => item !== null);
};

export const getFormattedCareType = (
  data: TabData,
  masterCareTypeState: ListOptions[],
  type?: number
): any => {
  const careTypeId = getValue(data, "requestService.referralCareTypeDto");

  const finalArray = masterCareTypeState
    .filter((masterCareType: any) =>
      careTypeId.some(
        (careType: any) => careType.careTypeId === masterCareType.value
      )
    )
    .map((masterCareType: any) => {
      return {
        careTypeId: masterCareType.value,
        careTypeName: masterCareType.label,
      };
    });
  if(type === 1){
    return finalArray;
  }
  return finalArray.map((item: any) => item.careTypeName).join(", ");
};


type DisciplineItem = {
    disciplineId: number;
    disciplineName: string;
    disciplineDescription: string;
    azCompeleteCheck: null;
    requestedVisits: number;
    effectiveFromDate: string;
    effectiveThroughDate: string;
    slotType: number;
    effectiveDateRange: string;
    endDateOfExistingDiscipline: string;
};
export interface ReAuthServiceRequest {
  memberAdmitted: string;
  inpatientAdmitDate: string;
  inpatientDischargeDate: string;
  disciplines: {
    disciplineId: number;
    discipline: string;
    currentVisit: number;
    nextVisit: number;
  }[];
  memberVisit: string;
  visitDate: string;
  startOfCare: string;
  currentStartDate: string;
  currentEndDate: string;
  nextStartDate: string;
  nextEndDate: string;
  userCreated: string;
  fullNameCreated: string;
  psychologicalDiseasesDto: any;
  isNurseToOpen: boolean;
}
export const getDisciplinesFromReAuthServiceRequest = (reAuthServiceRequest: ReAuthServiceRequest): DisciplineItem[] => {
    const disciplines: DisciplineItem[] = [];
    const disciplineList = reAuthServiceRequest.disciplines || [];
    disciplineList.forEach((discipline: any) => {
      const hasCurrent = discipline.currentVisit > 0;
      const hasNext = discipline.nextVisit > 0;

      if (hasCurrent) {
      const startDate = reAuthServiceRequest.currentStartDate;
      const endDate = reAuthServiceRequest.currentEndDate;
      disciplines.push({
        disciplineId: discipline.disciplineId,
        disciplineName: discipline.discipline,
        disciplineDescription: "",
        azCompeleteCheck: null,
        requestedVisits: discipline.currentVisit,
        effectiveFromDate: startDate ? formatDate(startDate, DateFormats.MM_DD_YYYY) : "",
        effectiveThroughDate: endDate ? formatDate(endDate, DateFormats.MM_DD_YYYY) : "",
        slotType: 1,
        effectiveDateRange:
        startDate && endDate
          ? `${formatDate(startDate, DateFormats.MM_DD_YYYY)} - ${formatDate(endDate, DateFormats.MM_DD_YYYY)}`
          : "",
        endDateOfExistingDiscipline: formatDate(discipline.date, DateFormats.MM_DD_YYYY),
      });
      }

      if (hasNext) {
      const startDate = reAuthServiceRequest.nextStartDate;
      const endDate = reAuthServiceRequest.nextEndDate;
      disciplines.push({
        disciplineId: discipline.disciplineId,
        disciplineName: discipline.discipline,
        disciplineDescription: "",
        azCompeleteCheck: null,
        requestedVisits: discipline.nextVisit,
        effectiveFromDate: startDate ? formatDate(startDate, DateFormats.MM_DD_YYYY) : "",
        effectiveThroughDate: endDate ? formatDate(endDate, DateFormats.MM_DD_YYYY) : "",
        slotType: 2,
        effectiveDateRange:
        startDate && endDate
          ? `${formatDate(startDate, DateFormats.MM_DD_YYYY)} - ${formatDate(endDate, DateFormats.MM_DD_YYYY)}`
          : "",
        endDateOfExistingDiscipline: formatDate(discipline.date, DateFormats.MM_DD_YYYY),
      });
      }
    });
    return disciplines;
};